import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { RichText } from '../rich-text/rich-text.esm.js';

/**
 * If there is no as value explitly defined then we should use the render value
 * @deprecated This logic will be removed with the component
 */ const getValidAs = (render, as)=>{
    const validAs = [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'p'
    ];
    const invalidRender = [
        'display-1',
        'display-2',
        'display-3',
        'display-4',
        'display-5',
        'display-6'
    ];
    if (!invalidRender.includes(render) && !as) {
        return render;
    }
    if (as && validAs.includes(`${as}`)) {
        return as;
    }
    return 'p';
};
/**
 * @deprecated This component is deprecated and will be removed in a future version.
 * Please use standard HTML elements with CSS classes instead.
 * See the type documentation above for migration examples.
 */ const Title = ({ render, as, className, ...rest })=>{
    // Show deprecation warning in development
    if (process.env.NODE_ENV === 'development') {
        const Component = getValidAs(render, as);
        const renderClass = render && as ? render : '';
        console.warn('⚠️  Title component is deprecated and will be removed in a future version.\n' + 'Please migrate to using standard HTML elements with CSS classes:\n' + `• Replace <Title render="${render}"${as ? ` as="${as}"` : ''}> with:\n` + `• <${Component} className="d-inline${renderClass ? ` ${renderClass}` : ''}${className ? ` ${className}` : ''}"> \n` + '• For string children, add dangerouslySetInnerHTML={{__html: stringContent}} and remove children prop');
    }
    const Component = getValidAs(render, as);
    return jsx(RichText, {
        as: Component,
        className: classNames('d-inline', {
            [render]: render && as
        }, className),
        ...rest
    });
};

export { Title };
